<template>
  <button
    class="tw-cursor-pointer tw-w-1/2 tw-p-4 tw-border-solid tw-border-gray-300 tw-rounded tw-border tw-bg-white tw-text-left focus-visible:tw-border-indigo-500 focus-visible:tw-focus-outline"
    :class="{ '!tw-border-indigo-500': active }"
    type="button"
    @click="$emit('updateFlow')"
  >
    <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
      <WdsIcon :size="34" :name="icon" class="tw-text-gray-600" />
      <WdsTag :success="tagType === 'success'" :warning="tagType === 'warning'">
        {{ tagText }}
      </WdsTag>
    </div>
    <div class="tw-font-medium">{{ title }}</div>
    <WdsText secondary>
      {{ infoText }}
    </WdsText>
  </button>
</template>

<script setup lang="ts">
import { WdsIcon, WdsTag, WdsText, WdsIconNameEnum } from '@worksome/wds-components'

defineEmits(['updateFlow'])

withDefaults(
  defineProps<{
    active?: boolean
    tagText: string
    tagType?: string
    title: string
    infoText: string
    icon?: WdsIconNameEnum
  }>(),
  {
    active: false,
    icon: WdsIconNameEnum.DASHBOARD,
    tagType: 'success',
  },
)
</script>
